import { FC } from 'react';
import * as ApiModels from '@typings/api-models';
import { Descendant } from 'slate';
import Modal from '@/components/Modal';
import ConversationThreadPage from '@/lib/ConversationThreadPage';

import s from './ConversationThreadModal.module.scss';

type Props = {
  onClose: () => void;
  onReply: () => void;
  conversationSid: string;
  messageId: string;
  editMessageFn?: (data: {
    id: string;
    text?: { children: Descendant[] }[];
    medias?: { id: string }[];
    handbooks?: { id: string }[];
    attachments?: ApiModels.CreateMessageAttachment[];
  }) => Promise<void>;
};

const ConversationThreadModal: FC<Props> = ({ onClose, onReply, conversationSid, messageId, editMessageFn }) => (
  <Modal isRightDrawer title="Thread" onClose={onClose}>
    <div className={s.modal}>
      <ConversationThreadPage
        conversationSid={conversationSid}
        onSendReply={onReply}
        messageId={messageId}
        editMessageFn={editMessageFn}
      />
    </div>
  </Modal>
);

export default ConversationThreadModal;
